/**
 * Created by jv on 17/07/2017.
 */
//js
const log = require("Sources/utils/logger")();
import Shared from "Sources/shared";
import LanguageManager from "Sources/services/language-manager";
import utils from "Sources/utils/utils";
import UserServices from "Sources/services/user-services";
import FormValidator from "Sources/components/form-validator";

//Styles
require("Styles/pages/reset-password.scss");

$(function () {
  Shared.init();

  ResetPasswordPage.init();
});

let ResetPasswordPage = {};

((ResetPasswordPage) => {
  let resetPasswordFormValidator;

  ResetPasswordPage.init = function () {
    $("#page-title").text(LanguageManager.getValueForKey("reset_password.title"));

    setUpForm();
    setUpEventListeners();
  };

  function setUpForm() {
    resetPasswordFormValidator = new FormValidator({
      selector: "#reset-password-form",
      validateOnChange: true,
      rules: {
        email: {
          required: false,
          validator: (value) => {
            return !utils.isNullOrEmpty(value) && value.trim() !== "";
          }
        }
      }
    });
  }

  function setUpEventListeners() {
    $("#reset-password-btn").off("click").on("click", function (e) {
      requestPasswordReset();
    });
  }

  function requestPasswordReset() {
    if (utils.isNull(resetPasswordFormValidator)) return;

    let $formFeedback = $("#reset-password-form").find(".form-feedback").empty().removeClass("form-feedback__valid");

    let formData = resetPasswordFormValidator.getFormData();
    let email = formData.email;

    if (resetPasswordFormValidator.validate()) {
      let $resetPasswordBtn = $("#reset-password-btn");
      $resetPasswordBtn.prop("disable", true).addClass("btn-loading");

      UserServices.requestPasswordReset(email)
        .then((data) => {
          log.info("Successfully requested password reset email");
          $formFeedback.text(LanguageManager.getValueForKey("reset_password.result.success.text")).addClass("form-feedback__valid");
        })
        .catch((err) => {
          log.error("Failed to request password reset email");

          if (err.code === "E91489") {
            $formFeedback.text(LanguageManager.getValueForKey("reset_password.result.fail.unknown_user.text"));
          } else {
            $formFeedback.text(LanguageManager.getValueForKey("reset_password.result.fail.unexpected.text"));
          }
        })
        .finally(() => {
          $resetPasswordBtn.prop("disable", false).removeClass("btn-loading");
        });
    }
  }
})(ResetPasswordPage);



// WEBPACK FOOTER //
// ./app/js/entries/reset-password.js